import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from '../../types.tsx';

export const setHasConcurrentUpdate =
	(hasConcurrentUpdate: boolean) =>
	({ setState }: StoreActionApi<State>) => {
		setState({ hasConcurrentUpdate, latestUpdate: undefined });
	};
